export const LOAD_DESIGN_LIBRARY_LIST = 'LOAD_DESIGN_LIBRARY_LIST';
export const SET_DESIGN_LIBRARY_SORT = 'SET_DESIGN_LIBRARY_SORT';
export const SET_DESIGN_LIBRARY_PAGINATION = 'SET_DESIGN_LIBRARY_PAGINATION';
export const SET_DESIGN_LIBRARY_FILTERS = 'SET_DESIGN_LIBRARY_FILTERS';
export const RESET_DESIGN_LIBRARY_FILTERS = 'RESET_DESIGN_LIBRARY_FILTERS';
export const LOAD_VIEW_DESIGN_LIBRARY = 'LOAD_VIEW_DESIGN_LIBRARY';
export const LOAD_DESIGN_LIBRARY_SETTINGS = 'LOAD_DESIGN_LIBRARY_SETTINGS';
export const ADD_DESIGN_LIBRARY_SETTINGS = 'ADD_DESIGN_LIBRARY_SETTINGS';
export const EDIT_DESIGN_LIBRARY_SETTINGS = 'EDIT_DESIGN_LIBRARY_SETTINGS';
export const DELETE_DESIGN_LIBRARY_SETTINGS = 'DELETE_DESIGN_LIBRARY_SETTINGS';
export const ADD_DESIGN_LIBRARY = 'ADD_DESIGN_LIBRARY';
export const LOAD_EDITTABLE_DESIGN_LIBRARY = 'LOAD_EDITTABLE_DESIGN_LIBRARY';
export const SET_EMPTY_EDITTABLE_DESIGN_LIBRARY = 'SET_EMPTY_EDITTABLE_DESIGN_LIBRARY';
export const EDIT_DESIGN_LIBRARY = 'EDIT_DESIGN_LIBRARY';
export const TOGGLE_DESIGN_LIBRARY_ITEM_STATE = 'TOGGLE_DESIGN_LIBRARY_ITEM_STATE';
export const ADD_DESIGN_VARIANT = 'ADD_DESIGN_VARIANT';
export const UPDATE_TRANSLATE_DESIGN_VARIANT = 'UPDATE_TRANSLATE_DESIGN_VARIANT';
export const LOAD_EDITTABLE_DESIGN_VARIANT = 'LOAD_EDITTABLE_DESIGN_VARIANT';
export const SET_EMPTY_EDITTABLE_DESIGN_VARIANT = 'SET_EMPTY_EDITTABLE_DESIGN_VARIANT';
export const EDIT_DESIGN_VARIANT = 'EDIT_DESIGN_VARIANT';
export const DELETE_DESIGN_LIBRARY = 'DELETE_DESIGN_LIBRARY';
export const DELETE_DESIGN_VARIANT = 'DELETE_DESIGN_VARIANT';
export const SET_DESIGN_VARIANT_PAGINATION = 'SET_DESIGN_VARIANT_PAGINATION';
export const SET_SELECTED_THEME_ID = 'SET_SELECTED_THEME_ID';
export const GO_TO_STEP_OF_DESIGN_FORM = 'GO_TO_STEP_OF_DESIGN_FORM';
export const SET_SELECTED_DESIGN = 'SET_SELECTED_DESIGN';
export const LOAD_LIBRARY_LIST = 'LOAD_LIBRARY_LIST';
export const SET_EDITABLE_SETTING_ID = 'SET_EDITABLE_SETTING_ID';
export const SET_EDITING_SETTING_VALUE = 'SET_EDITING_SETTING_VALUE';
export const SET_EDITABLE_DESIGN_VARIANT = 'SET_EDITABLE_DESIGN_VARIANT';
export const LOAD_EDITABLE_DESIGN_LIBRARY_FOR_DESIGN = 'LOAD_EDITABLE_DESIGN_LIBRARY_FOR_DESIGN';
export const CLEAR_VIEW_DESIGN_LISTING = 'CLEAR_VIEW_DESIGN_LISTING';
export const SET_EDITABLE_IMAGE_FILE_DESIGN_VARIANT = 'SET_EDITABLE_IMAGE_FILE_DESIGN_VARIANT';
export const SET_DESIGN_VARIANT_ID = 'SET_DESIGN_VARIANT_ID';
export const LOAD_FINISHING_PROPERTY_VALUES = 'LOAD_FINISHING_PROPERTY_VALUES';
export const SET_CHECKED_LIBRARYS = 'SET_CHECKED_LIBRARYS';
export const DOWNLOAD_PREVIEWS = 'DOWNLOAD_PREVIEWS';
export const RESET_DESIGN_LIBRARY_CHECKED = 'RESET_DESIGN_LIBRARY_CHECKED';
